export const LogoMark = ({ size = 36 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        aria-hidden="true"
    >
        <defs>
            <linearGradient
                id="logo-grad"
                x1="0"
                y1="0"
                x2="48"
                y2="48"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#00D2FF" />
                <stop offset="1" stopColor="#0088FF" />
            </linearGradient>
        </defs>
        <rect
            x="1.5"
            y="1.5"
            width="45"
            height="45"
            rx="12"
            fill="#0D121F"
            stroke="rgba(0,210,255,0.35)"
            strokeWidth="1.5"
        />
        <path
            d="M33 15.5 H20 a5.5 5.5 0 0 0 0 11 h8 a5.5 5.5 0 0 1 0 11 H15"
            stroke="url(#logo-grad)"
            strokeWidth="3.6"
            strokeLinecap="round"
        />
        <circle cx="33" cy="15.5" r="3" fill="#00D2FF" />
        <circle cx="15" cy="37.5" r="3" fill="#25D366" />
        <circle cx="24" cy="21" r="1.4" fill="#25D366" opacity="0.9" />
    </svg>
);

export const Logo = ({ compact = false }) => (
    <span className="flex items-center gap-3" data-testid="brand-logo">
        <LogoMark size={compact ? 32 : 38} />
        <span className="leading-none">
            <span className="block text-lg font-extrabold tracking-tight text-slate-50">
                Strondex<span className="text-cyan-400"> Tech</span>
            </span>
            {!compact && (
                <span className="mt-1 block text-[10px] font-semibold uppercase tracking-[0.24em] text-slate-500">
                    Campo Limpo · SP
                </span>
            )}
        </span>
    </span>
);
